var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___RUh6a0",
  "gs": "ChannelMessages.module__scrollerContainer___RUh6a0",
  "aE": "ChannelMessages.module__bottomFade___RUh6a0",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___RUh6a0",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___RUh6a0",
  "gT": "ChannelMessages.module__scrollerContent___RUh6a0",
  "lB": "ChannelMessages.module__scrollerSpacer___RUh6a0",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___RUh6a0",
  "pi": "ChannelMessages.module__fillerBuffer___RUh6a0",
  "CU": "ChannelMessages.module__groupSpacer___RUh6a0",
  "$P": "ChannelMessages.module__groupSpacerHalf___RUh6a0",
  "bv": "ChannelMessages.module__scrollerInner___RUh6a0",
  "eb": "ChannelMessages.module__newMessagesBar___RUh6a0",
  "mC": "ChannelMessages.module__newMessagesBarBanner___RUh6a0",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___RUh6a0",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___RUh6a0",
  "G6": "ChannelMessages.module__messageBottomPill___RUh6a0",
  "Sg": "ChannelMessages.module__jumpToPresentBar___RUh6a0",
  "RQ": "ChannelMessages.module__newMessagesBarText___RUh6a0",
  "As": "ChannelMessages.module__loadErrorBar___RUh6a0",
  "Ku": "ChannelMessages.module__newMessagesBarAction___RUh6a0",
  "WB": "ChannelMessages.module__unreadSlot___RUh6a0",
};

module.exports = exports;
